import React from 'react';
import SponsorshipInfoContainer from '../../../Containers/UserContainer/SponsorshipInfo';

const SponsorshipInfoScreen = () => {
  return <SponsorshipInfoContainer />;
};

export default SponsorshipInfoScreen;
